import React from 'react'

import Auth from '../../Auth'

import FormPage from '../FormPage'


export default class ClientProfile extends FormPage {
    static ShowRequired = true;

    static path = '/client/org/profile';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel client-profile-form';

    static MaxWidth = 800;

    /**
     * The title shown on the form
     */
    static FormTitle = "clients.edit_company_profile.title";

    /**
     * The api endpoint path that the form should send a post request to
     */
    static FormPost = "/api/clients/{client_id}/update";

    /**
     * The submit button title for the form
     */
    static FormSubmit = "clients.edit_company_profile.submit_button";

    /**
     * The fields mapping for the form
     */
    formFields()
    {
        let client = this.state.model;

        let firstRowFields = {
            name: {
                label   : 'clients.edit_company_profile.name_label',
                required: true,
                max: 255,
                style   : styles.field
            },

//         legal_name: {
//             label   : 'clients.edit_company_profile.legal_name_label',
//             required: false,
//             max: 255,
//             style   : styles.field
//         },

            size: {
                label   : 'clients.edit_company_profile.size_label',
                type    : 'select',
                required: true,
                options : laravel.client_sizes,
                style   : styles.field
            },
        };

        if (this.context.auth?.clientOrg?.()?.is_buyer) {
            firstRowFields.industry_id = {
                label   : 'clients.edit_company_profile.industry_label',
                type    : 'select',
                required: true,
                options : laravel.client_industries,
                style   : styles.field
            }
        }


        let sections = [
            {
                style : styles.fieldSection,
                fields: firstRowFields
            },
        ]

        sections.push({
            style : styles.fieldSection,
            fields: {
                location   : {
                    label   : 'clients.edit_company_profile.location_label',
                    type    : 'location',
                    required: false,
                    style   : styles.field
                }
            }
        })

        return sections.concat([
            {
                style : styles.fieldSection,
                fields: {
                    component: (
                        <hr/>
                    )
                }
            },
            {
                style : {...styles.fieldSection, alignItems: 'flex-start'},
                fields: {
                    logo_path: {
                        label: 'clients.edit_company_profile.logo_label',
                        type: 'pixie',
                        width: 150,
                        ratio: '1:1',
                        required: false,
                        columns: 4
                    },
                    banner_image_path: {
                        label   : 'clients.edit_company_profile.banner_image_label',
                        labelHint: TB.trans('clients.edit_company_profile.banner_image_hint'),
                        type: 'pixie',
                        ratio: '16:9',
                        width: 450,
                        circular: false,
                        required: false,
                        style: styles.field,
                        columns: 8,
                        shouldResize: true,
                    }
                }
            },
        ]);
    }

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @param context
     * @returns {FormPage}
     */
    constructor(props, context) {
        super(props, context);

        let user   = context?.auth,
            client = user && user.hasClientOrg()
                ? {...user.clientOrg()}
                : {};

        this.state = {
            ...this.state,
            model: client
        };
    }

    /**
     * Maps form input data to form submit model
     * Appends client id to form data from auth user assigned client
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model) {
        let user = this.context.auth;

        model.client_id = user.clientOrg().id;
        return model;
    }

    /**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
    onSuccess(responseData) {
        TB.alert(
            'success',
            'clients.edit_company_profile.success.title',
            'clients.edit_company_profile.success.message'
        );

        Auth.update({...responseData.data.auth});
    }


    render() {
        if (!this.context.auth?.hasClientOrg?.()) {
            return this.props.history.replace(TB.auth().appropriate())
        }
        return super.render();
    }
}


const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field       : {
        padding: '0 15px'
    }
};